// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"706db07a","547":"8b000562","649":"03afcf7b","658":"b8b9644e","775":"b2c10ae9","928":"22cc46bb","986":"271268f3"}[chunkId] + ".chunk.css";
};